export default "__VITE_ASSET__850afac5__"